import { MetadataFlags } from 'shared/consts/metadata-flags-enum';
import { useFieldMetadata } from 'hooks/use-ui-metadata.hook';

export const useIsExternalIdVisible = (orderNumber?: string): boolean => {
  const isExternalIdEnabled = useFieldMetadata(MetadataFlags.EXTERNAL_ID_ENABLED);

  return Boolean(isExternalIdEnabled && orderNumber);
};
